import {
  HubConnectionBuilder,
  HttpTransportType,
  HubConnectionState
} from '@microsoft/signalr';
import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';

// Utils
import { isNullUndefined } from '../services/utils';
import { MethodsName } from './signalRMethodsName';
import { userApi } from '../api';

// Redux
import {
  SignalRTypes,
  signalRDisconnect,
  signalRReceiveUpdates,
  signalRUserConnected
} from '../store/signalR';
import { ApplicationState } from '../store';
import { UserTypes } from '../store/user';

// Variables
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

// Create hub connection
const signalRConnectionHub = new HubConnectionBuilder()
  .withUrl(`${apiBaseUrl}xnuupHub`, {
    skipNegotiation: true,
    transport: HttpTransportType.WebSockets
  })
  .withAutomaticReconnect()
  .build();

export async function disconnectSignalRHub(): Promise<void> {
  try {
    await signalRConnectionHub.stop();
  } catch (error) {
    console.error('Error stopping SignalR connection', error);
  }
}

let areListenersRegistered = false;

const listenerSignalRMethods = (store: MiddlewareAPI<Dispatch<AnyAction>, ApplicationState>) => {
  if (areListenersRegistered) {
    return;
  }
  areListenersRegistered = true;

  // UserConnected
  signalRConnectionHub.on(
    MethodsName.UserConnected,
    (idConnectionSignalR: string) => {
      userApi.updateIdConnectionSignalR(idConnectionSignalR).then(() => {
        console.log('SignalR connected');
        store.dispatch(signalRUserConnected());
      });
    }
  );

  // ReceiveUpdates
  signalRConnectionHub.on(MethodsName.ReceiveUpdates, data => {
    if (!isNullUndefined(data)) {
      store.dispatch(signalRReceiveUpdates(data));
    }
  });

  // Default on close
  signalRConnectionHub.onclose(error => {
    console.log('SignalR disconnect');
    console.error('error', error);
    store.dispatch(signalRDisconnect());
  });
};

const signalRMiddleware: Middleware<{}, ApplicationState, Dispatch<AnyAction>> = (store) => (
  next
) => (action) => {
  const typedAction = action as AnyAction;
  switch (typedAction.type) {
    case SignalRTypes.SIGNALR_CONNECT:
      if (signalRConnectionHub.state === HubConnectionState.Disconnected) {
        signalRConnectionHub.start().then(() => {
          listenerSignalRMethods(store);
        });
      }
      break;
    case UserTypes.USER_ISLOGOUT:
    case SignalRTypes.SIGNALR_DISCONNECT:
      signalRConnectionHub.stop();
      break;
    default:
      break;
  }

  return next(action);
};

export default signalRMiddleware;

